export default __webpack_public_path__ + "static/media/sortIconUp.d01f58e5.svg";